import { createContext, useContext } from 'react';
import type { RootStore } from './store';
import { rootStore } from './store';

export const RootStoreContext = createContext<RootStore | null>(null);

export const RootStoreProvider = ({ children }: { children: React.ReactNode }) => {
    return <RootStoreContext.Provider value={rootStore}>{children}</RootStoreContext.Provider>;
};

export const useStore = <K extends keyof RootStore>(type: K) => {
    const rootStore = useContext(RootStoreContext);

    if (!rootStore) {
        throw new Error('useStore must be used within a StoreContextProvider');
    }

    return rootStore[type];
};

export const useAgentEditorStore = () => {
    return useStore('agentEditorStore');
};
